@if (toggleState) {
  <div class="expand-dismiss"
    (click)="toggleExpand()">
  </div>
}
<div class="expand-container flex flex-col items-end">
  <button mat-fab class="expand-toggle" [disabled]="busy"
    (click)="toggleExpand()">
    <app-icon icon="add" [spin]="busy" [@toggle]="{ value: toggleState ? 'active' : 'inactive' }" style="display: inline-block;"></app-icon>
  </button>
  <div class="expand-content" [@speedDialStagger]="{ value: toggleState ? 'active' : 'inactive' }">
    @if (toggleState) {
      <div class="button-container flex flex-col items-end">
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>
